
import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import HomePage from "../pages/home/page";
import LoginPage from "../pages/login/page";
import SignupPage from "../pages/signup/page";
import DashboardPage from "../pages/dashboard/page";
import GameLobbyPage from "../pages/game-lobby/page";
import ProfilePage from "../pages/profile/page";
import VIPPage from "../pages/vip/page";
import WalletPage from "../pages/wallet/page";
import SupportPage from "../pages/support/page";
import PromotionsPage from "../pages/promotions/page";
import GamePlay from "../pages/game-play/page";
import NotFoundPage from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/signup",
    element: <SignupPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/game/:id",
    element: <GameLobbyPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/vip",
    element: <VIPPage />,
  },
  {
    path: "/wallet",
    element: <WalletPage />,
  },
  {
    path: "/support",
    element: <SupportPage />,
  },
  {
    path: "/promotions",
    element: <PromotionsPage />,
  },
  {
    path: "/game-play",
    element: <GamePlay />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
